
import { motion } from "framer-motion";
import { useRef, useState } from "react";
import auth from "../../../helpers/auth";
import DatePicker from "react-datepicker";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import serverTimeHelper from "../../../helpers/serverTimeHelper";
import {
    dateNowByServer
} from "../../../helpers/date.js";

import axiosWithCacheConfig from "../../../helpers/axiosWithCacheConfig";

function Unhide({ referendum, setReferendum, titleSlug, setStep }) {

    const serverTime = serverTimeHelper.get();
    const initServerTime = serverTimeHelper.clientTime();
    const navigate = useNavigate();

    const reasonRef = useRef(null);

    const initDate = {
        min: moment(dateNowByServer(serverTime, initServerTime)).utc().toDate(),
        max: moment(dateNowByServer(serverTime, initServerTime)).add(3, "months").utc().toDate(),
    };
    const [startDate, setStartDate] = useState(moment(dateNowByServer(serverTime, initServerTime)).toDate());
    const [status, setStatus] = useState('loaded');


    const initErrors = {
        start_date: null,
        end_date: null,
        reason: null,
        others: null,
    };
    const [errors, setErrors] = useState(initErrors);


    function setDateToUTC(date, end = false) {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}T00:00:0${end ? '1' : '0'}.000Z`;
    }

    function onChangeReason(e) {
        setErrors({ ...errors, reason: null, others: null });
        setStatus('loaded');
    }

    function onSubmit(e) {
        e.preventDefault();
        setErrors(initErrors);
        let has_error = false;
        let temp_errors = { ...initErrors };
        let temp_status = status;

        if (has_error) {
            setErrors(temp_errors);
            setStatus('error');
            return
        }

        if (temp_status === 'updating') return;
        setStatus('updating');
        setErrors(initErrors);

        let url = process.env.REACT_APP_ENVIRONMENT === "development" ? `http://${process.env.REACT_APP_HOST}:3004/op/v1/referendums/${titleSlug}/moderate` : `https://api.onepeople.online/op/v1/referendums/${titleSlug}/moderate`;
        axiosWithCacheConfig
            .post(url,
                {
                    action: 'unmoderate',
                },
                {
                    headers: {
                        Authorization: `Bearer ${auth.getToken()}`,
                    },
                }
            )
            .then((res) => {
                if (res.data.success) {
                    setStatus('updated');
                    setStep('unhidden');
                    setTimeout(() => {
                        window.location.href = `/referendums/${titleSlug}`;
                    }, 500) 
                }
            })
            .catch((err) => {
                if (err?.response?.status === 400) {
                    let err_response = Object.assign({}, ...err.response.data.errors);
                    console.log(err_response)
                    setErrors({ ...errors, ...err_response });
                } else {
                    setErrors({ ...errors, others: "Something went wrong. Please try again." });
                }
                setStatus('loaded');
            })
    }

    return (
        <form className="px-4 moderation-form">
            <div className="col-12 row m-0 p-0">
                <div className="col-12 mt-2 mt-md-0 px-0 text-center">
                    <p className="op-text text-black mb-0">
                      Do you want to restore this referendum?
                    </p>
                    <div className="row mt-2">
                        <p className="col-12 col-md-10 mx-auto op-text mt-2 text-black">
                            Please note that restoring will make the referendum accessible or remove the moderation message for everyone.
                        </p>
                    </div>
                </div>
            </div>

            {(errors.others || errors.reason || errors.start_date || errors.end_date) && (
                <div className="m-0 p-0 text-left mt-1 text-center">
                    {errors.start_date && (
                        <p className="m-0 p-0 input-error text-red">
                            {errors.start_date}
                        </p>
                    )}
                    {errors.end_date && (
                        <p className="m-0 p-0 input-error text-red">
                            {errors.end_date}
                        </p>
                    )}
                    {errors.reason && (
                        <p className="m-0 p-0 input-error text-red">
                            {errors.reason}
                        </p>
                    )}
                    {errors.others && (
                        <p className="m-0 p-0 input-error text-red">
                            {errors.others}
                        </p>
                    )}
                </div>
            )}

            <div className="d-flex justify-content-center mt-4">
                <motion.input
                    initial={{}}
                    animate={
                        (status === 'updating' || status === 'error')
                            ? { backgroundColor: "#ccc", cursor: "not-allowed" }
                            : {}
                    }
                    onClick={onSubmit}
                    type="submit"
                    name="submit"
                    value="Submit"
                    className="bounce op-btn delete-btn"
                />
            </div>
        </form>
    )
}

export default Unhide;